<template>
    <span>
        <el-button type="primary" size="mini" plain @click="setVisible(true)" title="Edit">
            Edit
        </el-button>
        <el-dialog title="Edit Step" :visible.sync="dialogVisible">
            <el-form :model="form" :rules="rules" ref="form" @submit.prevent.native="onSubmit('form')">
                <el-form-item label="Instruction" prop="content">
                    <el-input v-model="form.content" placeholder="Enter detailed instruction" type="textarea" :autosize="{ minRows: 2 }"></el-input>
                </el-form-item>
                <el-button native-type="submit" type="primary" :loading="loading">Save</el-button>
                <el-button @click="onCancel('form')">Cancel</el-button>
            </el-form>
        </el-dialog>
    </span>
</template>

<script>
export default {
    data() {
        return {
            loading: false,
            dialogVisible: false,
            form: {
                content: this.step.content,
            },
            rules: {
                'content': [
                    { required: true, message: 'Enter an instruction.', trigger: 'blur' },
                ],
            },
        }
    },

    props: {
        step: {
            type: Object,
        },
    },

    methods: {
        onSubmit(form) {
            this.loading = true

            this.$refs[form].validate(async valid => {
                if (!valid) {
                    this.loading = false

                    return false
                }

                try {
                    var { data } = await this.$http.put(`/ingredient-steps/${ this.step.id }`, {
                        locale: 'en',
                        content: this.form.content,
                    })
                } catch(err) {
                    this.$message.error(err.response.data.message)

                    return false
                } finally {
                    this.loading = false
                }

                this.setVisible(false)
                this.$emit('update')
                this.$refs[form].resetFields()
                this.$message.success(data.message)
            })
        },

        onCancel(form) {
            this.setVisible(false)
            this.$refs[form].resetFields()
        },

        setVisible(status) {
            this.dialogVisible = status
        },
    },
}
</script>

<style scoped>
.el-input .el-select {
    width: 14rem;
}
</style>
